
export function getDiscreteChartColors() {
  const styles = getComputedStyle(document.documentElement)

  const getPropertyValue = (prop) =>
    styles.getPropertyValue(prop).trim() || "rgba(0,0,0,0.1)"

  return [
    getPropertyValue("--disc-color-01"),
    getPropertyValue("--disc-color-02"),
    getPropertyValue("--disc-color-03"),
    getPropertyValue("--disc-color-04"),
    getPropertyValue("--disc-color-05"),
    getPropertyValue("--disc-color-06"),
    getPropertyValue("--disc-color-07"),
    getPropertyValue("--disc-color-08"),
    getPropertyValue("--disc-color-09"),
    getPropertyValue("--disc-color-10"),
    getPropertyValue("--disc-color-11"),
    getPropertyValue("--disc-color-12"),
    getPropertyValue("--disc-color-13"),
    getPropertyValue("--disc-color-14"),
  ]
}